define('models/content',[
  "globals",
  "backbone",
  "URIjs",
  "history"
], function (globals, Backbone, URI, History) {
  "use strict";

  return Backbone.Model.extend({
    defaults: {
      highlight: [],
      filter: _.clone(globals.state.filter)
    },

    initialize: function () {
      _.bindAll(this, "saveFilter", "updateLocationFromURI");

      this.on("change:filter", this.saveFilter);

      this.setLocationHighlights();

      History.Adapter.bind(window, "statechange", _.bind(function () {
        if (this.locationHasChanged()) {
          this.set("location", History.getState().data);
        }
      }, this));
    },

    setLocationHighlights: function () {
      var uri = URI(window.location.href);

      try {
        if (uri.hasQuery("highlight")) {
          this.set("highlight", [uri.query(true).highlight]);
        }
      } catch (e) {
        // This is just to make IE8 happy.
      }

      return this;
    },

    saveFilter: function () {
      globals.state.filter = this.get("filter");

      if (_.has(window, "localStorage")) {
        window.localStorage.setItem("state", JSON.stringify(globals.state));
      }
    },

    makeUrl: function (base) {
      base = base || "";

      var l = this.get("location"),
       path = URI.joinPaths(base, l.library, l.version, l.language, l.path).path(),
        uri = this.getURIWithHash(new URI(path));

      return uri;
    },

    getContentBaseURI: function () {
      return new URI($("main").data("content-base"));
    },

    url: function () {
      return this.makeUrl($("main").data("base"));
    },

    getContentURI: function () {
      return this.makeUrl(this.getContentBaseURI().path());
    },

    getURIWithHash: function (uri) {
      var l = this.get("location");

      if (this.has("location") && _.has(l, "hash")) {
        if (l.hash.length > 0 && !l.hash.match(/^\#[a-zA-Z][\w:.-]*$/)) {
          globals.log("ERROR",
            "HTML ID '" + l.hash + "' contains illegal character(s).");
        }

        uri.hash(l.hash);
      }

      return uri;
    },

    locationHasChanged: function () {
      return this.has("location") &&
        !_.isEqual(History.getState().data, this.get("location"));
    },

    updateHistory: function (title) {
      // Fix base URL for emulated history support
      if (History.emulated.pushState) {
        $("title").get(0).text = title;
      }

      History.pushState(this.get("location"), title,
        this.getContentURI().href()
      );

      return this;
    },

    updateLocationFromURI: function (uri) {
      var newLocation,
          currentLocation = this.get("location"),
          href = uri.path();

      // A link like this that points to another library or a different version
      // of the same library:
      //
      //   /content/org.oasis-open.dita/1.2.0/en/language_reference.html
      if (href.charAt(0) === "/") {
        var pathComponents = href.split(this.getContentBaseURI())[1].split("/");

        newLocation = {
          library: pathComponents[1],
          version: pathComponents[2],
          language: pathComponents[3],
          path: pathComponents.slice(4).join("/"),
          hash: uri.hash()
        };
      } else {
        newLocation = {
          path: uri.absoluteTo(currentLocation.path).path(),
          hash: uri.hash()
        };
      }

      this.set("location",
        _.defaults(newLocation, this.get("location")));

      return this;
    }
  });
});

